export const IDS = 'ids';
export const PROMO_CODE = 'promoCodeId';
export const NAMES = 'names';
